module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "ian_goes_cover.e9be1e80.jpg";